import React from "react";

export const AuthPermission = () => {
  return <></>;
};
